// extracted by mini-css-extract-plugin
export default {"container":"page-body_container__RAPQJ","seperator":"page-body_seperator__K97mP"};